module.exports = __webpack_public_path__ + "img/vessel_drive_green.339d2812.jpg";